<div class="cart-wrapper">
    <button  class="close-btn data-protection-close delete-cart-popup-btn" aria-label="close dialog" mat-dialog-close>
      <img src="/icons/close-kb.svg" alt="" width="20" height="20" />
  </button>
    <mat-dialog-content class="delete-cart-dialog">
        <div class="confirm-text">
          {{'common.text_account_warranty_table_header_dsiplay_claim_number'|cxTranslate}}
        </div>
        <br>

        <div class="confirm-text-next">
            {{'common.text_account_warranty_table_header_dsiplay_claim_number_content'|cxTranslate}}
          </div>
    </mat-dialog-content>
    <mat-dialog-actions class="col-12 delete-confirm-action">
        <button class="mat-primary  mat-accept delete-cart-confirmation" (click)="openPDF()" mat-button>
            {{'common.text_account_warranty_table_header_dsiplay_claim_number_button_pdf'|cxTranslate}}</button>
        <button class="mat-primary  mat-accept no-delete" (click)="navToSubmit()" mat-button>
            {{'common.text_account_warranty_table_header_dsiplay_claim_number_button_template'|cxTranslate}}</button>
    </mat-dialog-actions>
  </div>
  